module.exports = __webpack_public_path__ + "static/rfa-home@2x-150x150-93261a63e76db2f460335c0f45747ceb.png";